import {
  getChannelsList,
  deleteChannel as deleteChannelRequest,
  getChannel as getChannelRequest
} from "../../requests/channels";
export const types = {
  GET_ALL_CHANNELS_REQUEST: 'GET_ALL_CHANNELS_REQUEST',
  GET_ALL_CHANNELS_SUCCESS: 'GET_ALL_CHANNELS_SUCCESS',
  GET_ALL_CHANNELS_FAILURE: 'GET_ALL_CHANNELS_FAILURE',
  DELETE_CHANNEL_REQUEST: 'DELETE_CHANNEL_REQUEST',
  DELETE_CHANNEL_SUCCESS: 'DELETE_CHANNEL_SUCCESS',
  DELETE_CHANNEL_FAILURE: 'DELETE_CHANNEL_FAILURE',
  GET_CHANNEL_REQUEST: 'GET_CHANNEL_REQUEST',
  GET_CHANNEL_SUCCESS: 'GET_CHANNEL_SUCCESS',
  GET_CHANNEL_FAILURE: 'GET_CHANNEL_FAILURE',
}

export const getAllChannels = () => {
  return (dispatch) => {
    dispatch({ type: types.GET_ALL_CHANNELS_REQUEST });
    getChannelsList()
      .then(response => {
        dispatch({
          type: types.GET_ALL_CHANNELS_SUCCESS,
          payload: response.data
        })
      })
      .catch(error => {
        dispatch({
          type: types.GET_ALL_CHANNELS_FAILURE,
          error
        })
      })
  }
}

export const deleteChannel = channel => {
  return (dispatch) => {
    dispatch({ type: types.DELETE_CHANNEL_REQUEST, id: channel.id });
    deleteChannelRequest(channel.id, channel.type)
      .then(() => {
        dispatch({
          type: types.DELETE_CHANNEL_SUCCESS,
          id: channel.id
        })
      })
      .catch(() => {
        dispatch({
          type: types.DELETE_CHANNEL_FAILURE,
          id: channel.id
        })
      })
  }
}

export const getChannel = id => {
  return (dispatch) => {
    dispatch({ type: types.GET_CHANNEL_REQUEST, id });
    getChannelRequest(id)
      .then(response => {
        dispatch({
          type: types.GET_CHANNEL_SUCCESS,
          channel: response.data
        })
      })
      .catch(error => {
        dispatch({
          type: types.GET_CHANNEL_FAILURE,
          error
        })
      })
  }
}